export default __webpack_public_path__ + "static/media/profile.175041f5.svg";